import React from 'react';
import withStyles from '@material-ui/core/styles/withStyles';
import PropTypes from 'prop-types';

import {
    IconButton
} from '@material-ui/core';

import KeyboardArrowRightIcon from '@material-ui/icons/KeyboardArrowRight';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import { togglePrimaryPanelCompact, toggleSecondaryPanelCompact } from '../../../redux/panel/Actions';
import { compose } from 'redux';
import { connect } from 'react-redux';

class PanelHeader extends React.Component {
    static propTypes = {
        classes: PropTypes.object.isRequired,
        isCompact: PropTypes.bool.isRequired,
        isExpandable: PropTypes.bool.isRequired,
        onClick: PropTypes.func.isRequired
    };

    static defaultProps = {
        isExpandable: true
    };

    constructor (props) {
        super(props);
    }

    render () {
        const { classes, isCompact, isExpandable, onClick, children } =this.props;
        return (
            <div
                className={classes.root}
            >
                {children}
                {
                    isExpandable && <IconButton
                        className={classes.toggleHeaderButton}
                        onClick={onClick}
                    >
                        {
                            isCompact ?
                                <KeyboardArrowRightIcon /> :
                                <KeyboardArrowDownIcon />
                        }
                    </IconButton>
                }

            </div>
        );
    }
}

const style = theme => ({
    root: {
        minHeight: theme.constants.panelHeader,
        height: theme.constants.panelHeader,
        display: 'flex',
        alignItems: 'center',
        borderBottom: `1px solid ${theme.palette.grey.variant5}`,
        padding: `0px ${theme.constants.spacing.xl}px`,
        position: 'relative',
        color: theme.palette.text.primary,
        '& > *:not(:first-child)': {
            marginLeft: 10
        }
    },
    toggleHeaderButton: {
        marginLeft: 'auto !important',
        width: '24px',
        height: '24px',
        minWidth: 0,
        color: theme.palette.grey.variant5
    }
});

const mapStateToProps = (state, ownProps) => {
    const panelsState = state.panels;
    return {
        isCompact: ownProps.isPrimary ?
            panelsState.panels[panelsState.primaryPanel].compact :
            panelsState.panels[panelsState.secondaryPanel].compact
    };
};
//
// const mapDispatchToProps = (dispatch, ownProps) => ({
//     onTogglePanelCompact: () => dispatch(ownProps.isPrimary ? togglePrimaryPanelCompact() : toggleSecondaryPanelCompact()),
// });
//
// export default compose(
//     connect(mapStateToProps, mapDispatchToProps),
//     withStyles(style)
// )(PanelHeader);


export default withStyles(style)(PanelHeader);